export const IN_PROGRESS_TITLE = "In Progress";
export const COMPLETED_TITLE = "Recent activity";
export const NOTIFICATIONS_PANEL_TITLE = "Notifications";
export const EMPTY_STATE_TITLE = "No notifications yet";
export const EMPTY_STATE_SUBTITLE = "Notifications will appear here once there is activity.";

export const SECTION_TYPE = {
  HEADER: "header",
  ITEM: "item",
  LOADING: "loading"
};

export const HEADER_HEIGHT = 34;
export const ITEM_HEIGHT = 140;
export const ITEM_HEIGHT_WITH_PUBLISH_DESCRIPTION = 172;
export const LOADING_HEIGHT = 140;
